import { MAX_MOBILE_WIDTH, isMobileDevice } from './isMobileDevice';

export type EnvironmentGuideVariant = 'narrowScreen';

export const getEnvironmentGuideVariant = (): EnvironmentGuideVariant | null => {
  if (isMobileDevice()) {
    return null;
  }

  if (window.innerWidth < MAX_MOBILE_WIDTH) {
    return 'narrowScreen';
  }

  return null;
};
